import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  ElementRef,
  QueryList,
} from '@angular/core';

@Component({
  selector: 'app-template7',
  templateUrl: './template7.component.html',
  styleUrls: ['./template7.component.scss'],
})
export class Template7Component {
  @Input() data: any;
  @Input() isThumbnail: boolean = false;

  @ViewChild('measureContainer') measureContainer!: ElementRef;
  @ViewChildren('sectionRefs', { read: ElementRef })
  sectionRefs!: QueryList<ElementRef>;

  allSections: any[] = [];
  pages: any[][] = [];

  ngOnInit(): void {}

  trackByIndex(i: number) {
    return i;
  }
}
